import { c as _c } from "react-compiler-runtime";
import baseStyled, { css as baseCss, useTheme as baseUseTheme } from 'styled-components';
import omit from 'transmute/omit';
import { MIN_SIDEBAR_WIDTH, SIDEBAR_ANIMATION_DURATION_SECONDS } from '../constants/sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
export function styledWithOmittedProps(Component, propsToIgnore = []) {
  const WithOmittedProps = props => {
    "use memo";

    const $ = _c(4);
    let t0;
    if ($[0] !== props) {
      t0 = omit(propsToIgnore, props);
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    if ($[2] !== t0) {
      t1 = /*#__PURE__*/_jsx(Component, Object.assign({}, t0));
      $[2] = t0;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  };
  return baseStyled(WithOmittedProps);
}
const getSidebarWidth = ({
  open
}) => {
  return `${open ? MIN_SIDEBAR_WIDTH : 0}px`;
};
export const getSidebarWidthStyles = props => {
  return {
    width: getSidebarWidth(props),
    minWidth: getSidebarWidth(props),
    maxWidth: '26vw',
    transition: `width ${SIDEBAR_ANIMATION_DURATION_SECONDS}s, min-width ${SIDEBAR_ANIMATION_DURATION_SECONDS}s`
  };
};
export const styled = baseStyled;
export const css = baseCss;
export const useTheme = baseUseTheme;